export enum pageEnums {
    products = 'products',
    carts = 'carts',
    orders = 'orders'
}
